<div>
  <form [formGroup]="group" (submit)="submit(group.value)">
    <div *ngIf="!esignCompleted" class="insured-esign-container">
      <div class="insured-esign-card">
        <section class="insured-esign-card__content">
          <header class="insured-esign-card__header">
            <h1 class="insured-esign-card__heading">Verify your identity to continue</h1>
            <div class="insured-esign-card__divider"></div>
          </header>
          <div class="insured-esign-card__body">
            <p class="insured-esign-card__body-text">Enter the last four digits of your social security number.</p>
            <div class="insured-esign-card__enter-ssn">
              <cp-form-field>
                <input
                  cpInput
                  formControlName="ssnLastFour"
                  placeholder="####"
                  class="form-field__input cp-box__input insured-esign-card__last-four"
                  [ngClass]="{
                    'cp-box__input--error': group.get('ssnLastFour').touched && group.get('ssnLastFour').invalid
                  }"
                />

                <cp-error>
                  {{ group.get('ssnLastFour').errors | humanizeFormMessages }}
                </cp-error>
              </cp-form-field>
            </div>
            <div>
              <cp-error *ngIf="unauthorized && attemptsRemaining > 0">
                Invalid last 4 digits, you have {{ attemptsRemaining }} attempts remaining
              </cp-error>
              <cp-error *ngIf="unauthorized && attemptsRemaining <= 0">
                Too many attempts, please contact
                <a href="mailto:DigitalCustomerSupport@massmutual.com">DigitalCustomerSupport@massmutual.com</a>
              </cp-error>
            </div>
          </div>
          <div class="button-container">
            <button
              class="button button--blue button--primary"
              [ngClass]="{
                'button--disabled': group.invalid || attemptsRemaining <= 0
              }"
              type="submit"
              [disabled]="group.invalid || attemptsRemaining <= 0"
            >
              Submit
            </button>
          </div>
        </section>
      </div>
    </div>
  </form>

  <div *ngIf="esignCompleted" class="insured-esign-finished">
    <div class="header">You are all set!</div>
    <div class="sub-header">Thank you for signing.</div>
  </div>

  <loading *ngIf="loadingScreen"></loading>
</div>
